'use client';

function getAdaptiveHeightList(element) {
    var result = [];
    var lists = element.childNodes;
    if (lists && lists.length > 0) {
        lists.forEach(function (list) {
            var stackedHeight = 0;
            if (list.childNodes && list.childNodes.length > 0) {
                list.childNodes.forEach(function (item) {
                    stackedHeight += item.offsetHeight;
                });
                result.push(stackedHeight);
            }
        });
    }
    return result;
}

export { getAdaptiveHeightList as default };
//# sourceMappingURL=getAdaptiveHeightList.js.map
